import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
	.use(HttpBackend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		supportedLngs: ["pt"],
		fallbackLng: "pt",
		debug: import.meta.env.DEV,
		defaultNS: "common",
		fallbackNS: "common",
		ns: ["common"],

		backend: {
			loadPath: "/static/locales/{{lng}}/{{ns}}.json",
		},

		interpolation: {
			// not needed for react as it escapes by default
			escapeValue: false,
		},
	});

export default i18n;
